export enum ConsentType {
    SpouseDetail = 'SpouseDetail'
}
